import React from "react";
import { Box, Typography } from "@mui/joy";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ActionsMenu } from "@dreebit-registry/vsm-microservice-components";
import { MoreVertRounded } from "@mui-symbols-material/w300";
import { WidgetActionsMenu } from "../WidgetActionsMenu";
import WelcomeHeroSurface, { HERO_IMAGE_HIDDEN_QUERY } from "../WelcomeHero/WelcomeHeroSurface";
import { useIndustryType, IndustryType } from "../../hooks/useIndustryType";

interface Props {
  onDelete: () => void;
  onEdit: () => void;
}

const WelcomeBannerWidget: React.FC<Props> = ({ onDelete, onEdit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isArgos = useIndustryType() === IndustryType.SEMICONDUCTOR;
  const actionItems = WidgetActionsMenu(onDelete, onEdit);

  return (
    <WelcomeHeroSurface style={{ cursor: "grab" }} imageOffsetY={-10}>
      <div className="no-drag" style={{ position: "absolute", top: 6, right: 6, zIndex: 2 }}>
        <ActionsMenu
          items={actionItems}
          icon={<MoreVertRounded fontSize="small" sx={{ color: "rgba(255,255,255,0.85)" }} />}
        />
      </div>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "6px",
          padding: "16px 56px 16px clamp(48px, calc(42% + 24px), 664px)",
          [HERO_IMAGE_HIDDEN_QUERY]: { padding: "16px 24px" },
        }}
      >
        <Typography level="bodySmall" sx={{ color: "primary.300", fontWeight: 600 }}>
          {"● "}
          {isArgos ? "ARGOS Digital Services" : "OTTO Digital Services"}
        </Typography>
        <Typography level="titleMedium" sx={{ color: "#fff" }}>
          {isArgos ? t("Welcome to the new IBM System powered by ARGOS") : t("Welcome to the new OTTO platform")}
        </Typography>
        <Typography level="bodySmall" sx={{ color: "rgba(255,255,255,0.78)" }}>
          {isArgos
            ? `${t("ARGOS IBM is your centralized platform for managing installed equipment, service activities, and asset history — with complete visibility into your installed base.")} ${t("Take a quick look at the most important new capabilities.")}`
            : `${t("OTTO is now part of the Busch Group Customer Portal, giving you centralized access to your installed equipment and digital services.")} ${t("Take a quick look at the most important improvements in the new platform.")}`}
        </Typography>
        <div className="no-drag" style={{ marginTop: 6 }}>
          <Button size="small" variant="contained" onClick={() => navigate("/profile/about")}>
            {t("Explore what's new")}
            {" →"}
          </Button>
        </div>
      </Box>
    </WelcomeHeroSurface>
  );
};

export default WelcomeBannerWidget;
